export var ISignUpAttribution;
(function (ISignUpAttribution) {
    let SignUpAttributionType;
    (function (SignUpAttributionType) {
        SignUpAttributionType["OTHER"] = "OTHER";
        SignUpAttributionType["REFERRAL_LINK"] = "REFERRAL_LINK";
        SignUpAttributionType["WORD_OF_MOUTH"] = "WORD_OF_MOUTH";
        SignUpAttributionType["TRADESHOW"] = "TRADESHOW";
        SignUpAttributionType["FACEBOOK"] = "FACEBOOK";
        SignUpAttributionType["INSTAGRAM"] = "INSTAGRAM";
        SignUpAttributionType["GOOGLE"] = "GOOGLE";
        SignUpAttributionType["WEBSITE"] = "WEBSITE";
        SignUpAttributionType["PHYSICAL_MAIL"] = "PHYSICAL_MAIL";
        SignUpAttributionType["AMERICAN_EXPRESS"] = "AMERICAN_EXPRESS";
        /**
         * Attributions specific to sign-up survey
         */
        SignUpAttributionType["SURVEY_REFERRAL"] = "SURVEY_REFERRAL";
        SignUpAttributionType["SURVEY_WORD_OF_MOUTH"] = "SURVEY_WORD_OF_MOUTH";
        SignUpAttributionType["SURVEY_FACEBOOK"] = "SURVEY_FACEBOOK";
        SignUpAttributionType["SURVEY_INSTAGRAM"] = "SURVEY_INSTAGRAM";
        SignUpAttributionType["SURVEY_SEARCH_ENGINE"] = "SURVEY_SEARCH_ENGINE";
        SignUpAttributionType["SURVEY_WEBSITE"] = "SURVEY_WEBSITE";
        SignUpAttributionType["SURVEY_PHYSICAL_MAIL"] = "SURVEY_PHYSICAL_MAIL";
        SignUpAttributionType["SURVEY_FAIRE_BLOG"] = "SURVEY_FAIRE_BLOG";
        SignUpAttributionType["SURVEY_FAIRE_PODCAST"] = "SURVEY_FAIRE_PODCAST";
        SignUpAttributionType["SURVEY_PINTEREST"] = "SURVEY_PINTEREST";
        SignUpAttributionType["SURVEY_OTHER"] = "SURVEY_OTHER";
        /**
         * Indicates that the user visited 'https:www.faire.com/markets' before signing up
         */
        SignUpAttributionType["FAIRE_MARKETS_PAGE"] = "FAIRE_MARKETS_PAGE";
        /**
         * Signed up directly from Fashion Week landing page
         * @deprecated
         */
        SignUpAttributionType["FASHION_WEEK"] = "FASHION_WEEK";
        /**
         * Signed up directly from Shopify retailer app
         */
        SignUpAttributionType["SHOPIFY"] = "SHOPIFY";
    })(SignUpAttributionType = ISignUpAttribution.SignUpAttributionType || (ISignUpAttribution.SignUpAttributionType = {}));
    /**
     * Return an instance of ISignUpAttribution with the provided fields. Any field not
     * listed will be populated with an empty value (an empty array,
     * or undefined, whichever is valid for the type of the value.)
     */
    ISignUpAttribution.build = (partial) => (Object.assign({}, (partial !== null && partial !== void 0 ? partial : {})));
})(ISignUpAttribution || (ISignUpAttribution = {}));
